<template>
<section class="container">
  <template v-if="showPage">
    <template v-if="tabList.length > 0">
      <!-- 选择购券类型 -->
      <section class="select_box" v-if="tabList.length > 1">
        <h2>选择购券类型</h2>
        <section class="tab_list">
          <span :class="[tabIndex==index?'cur':'']" v-for="(item,index) in tabList" :key="item" @click="tabClick(item,index)">{{item | couponType}}</span>
        </section>
      </section>
      <!-- 轮播 -->
      <swiper :options="options" class="swiper">
        <swiper-slide v-for="(item,index) in curCouponData" :key="index">
          <coupon-item :item="item" :showLastBox="false"></coupon-item>
        </swiper-slide>
        <div class="swiper-pagination" v-show="curCouponData.length>1" slot="pagination"></div>
      </swiper>
      <!-- 单价 -->
      <section class="coupon_data">
        <img v-if="hasTenantPrice" class="img_discount" src="../../assets/images/img_discount.png" />
        <section class="coupon_data_left">
          <template v-if="hasTenantPrice">
            <p>单价:<span>{{tenantPrice}}</span>元/张</p>
            <i>{{curCouponData[activeIndex].price}}元/张</i>
          </template>
          <p v-else>单价:<span>{{curCouponData[activeIndex] && curCouponData[activeIndex].price}}</span>元/张</p>
        </section>
        <section class="coupon_data_right">
          <p v-if="curCouponData[activeIndex]">剩余可购: {{curCouponData[activeIndex].couponNumber-curCouponData[activeIndex].overCouponNumber}}</p>
        </section>
      </section>
      <!-- 购买数量 -->
      <section class="buy_num">
        <h3>购买券数</h3>
        <section class="num_box">
          <span class="num_box_left" @click="reduce"></span>
          <input class="num_box_center" type="tel" v-model="couponNumber" @input="inputV" @blur="blur"/>
          <span class="num_box_left num_box_right" @click="add"></span>
        </section>
        <mt-button class="btn_login" @click="buy">立即购买</mt-button>
      </section>
    </template>
    <div class="no_mess" v-else>
      <img src="../../assets/images/img_blank_coupon_park.png" />
      <p>暂无可购停车券~</p>
   </div>
  <!-- 底部 -->
  <section class="footer_box" @click="toBuyRecord">
    <p>购券记录</p>
  </section>
  </template>
</section>
</template>
<script>
import {mapState} from 'vuex'
import {callSpaceUp} from '../../utils/api'
import util from '../../utils/util'
import CouponItem from './components/couponItemT'
export default {
  name: 'buyCoupon',
  props: {

  },
  components: {
    CouponItem
  },
  filters: {
    couponType(val){
      if(val == 1){
        return '免费券'
      }else if(val == 2){
        return '金额券'
      }else if(val == 3){
        return '时间券'
      }else{
        return '折扣券'
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      showPage:false,
      options: {
        pagination: ".swiper-pagination",
        paginationType: "bullets",
        // observeParents: true,
        autoplay: false,
        speed: 500,
        loop:false,
        slidesPerView: 1,//设置slider容器能够同时显示的slides数量
        spaceBetween: 10,//在slide之间设置距离（单位px）。
        onSlideChangeStart:swiper=>{
          this.activeIndex = swiper.activeIndex;
          // 获取员工优惠价
          if(Object.keys(this.common.userTenantInfo).length > 0){
            this.queryCouponCompany(this.curCouponData[swiper.activeIndex].id)
          }
        },
      },
      couponData:[],//券数据
      curCouponData:[],//当前优惠券类型数据
      tabList:[],
      tabIndex:'0',
      couponT:'',////券类型
      activeIndex:0,//同类券里面券索引
      couponNumber:1,//购买券数量
      hasTenantPrice:false,
      tenantPrice:0,
      btnCanClick:true,
    }
  },
  activated(){
    this.tabIndex = '0';
    this.activeIndex = 0;
    this.queryParkCouponHeaderList()
  },
  methods:{
    blur(){
      setTimeout(function(){
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
      if(this.couponNumber < 1){
        this.couponNumber = 1
      }
    },
    // 获取优惠券列表
    queryParkCouponHeaderList(){
      util.showLoading()
      let params = {
        subProjectId:this.common.marketInfo.id,
        prkHeaderId:this.$route.query.prkHeaderId || '',
        url:"/parking/rstParkCoupon/queryParkCouponHeaderList"
      }
      callSpaceUp(params).then(res=>{
        console.log(res)
        util.hideLoading()
        this.showPage = true;
        if(res.res.code === 10000 && res.body){
          let data = res.body.data || [],tabList = [],curCouponData= [];
          this.couponData = data;
          data.forEach(item=>{
            tabList.push(item.couponType)
            // 设置默认的优惠券类型数据
            if(item.couponType == data[0].couponType){
              curCouponData.push(item)
            }
          })
          tabList = [...new Set(tabList)];
          this.tabList = tabList;
          this.couponT = tabList[0];
          this.curCouponData = curCouponData;
          // 获取员工优惠价
          if(Object.keys(this.common.userTenantInfo).length > 0){
            this.queryCouponCompany(curCouponData[0].id)
          }
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    // 获取优惠价
    queryCouponCompany(id){
      util.showLoading()
      let params = {
        couponHeaderId:id,//优惠券id
        companyId:this.common.userTenantInfo.companyId,//默认认证企业的id
        url:"/parking/rstParkCoupon/queryCouponCompany"
      }
      callSpaceUp(params).then(res=>{
        console.log(res)
        util.hideLoading()
        if(res.res.code === 10000 && res.body && res.body.data && res.body.data.price){
          this.hasTenantPrice = true;
          this.tenantPrice = res.body.data.price;
        }else{
          this.hasTenantPrice = false;
        }
      })
    },
    // 切换券类型
    tabClick(item,index){
      this.tabIndex = index;
      this.couponT = item;
      this.activeIndex = 0;
      this.couponNumber = 1;
      this.hasTenantPrice = false;
      let curCouponData = [];
      this.couponData.forEach(cur=>{
        if(item == cur.couponType){
          curCouponData.push(cur)
        }
      })
      this.curCouponData = curCouponData;
      // 获取员工优惠价
      if(Object.keys(this.common.userTenantInfo).length > 0){
        this.queryCouponCompany(curCouponData[0].id)
      }
    },
    // 立即购买
    buy(){
      if(!this.btnCanClick){
        return false;
      }
      this.btnCanClick = false;
      util.showLoading()
      let params = {
        subProjectId: this.common.marketInfo.id,//项目id
        prkHeaderId:this.$route.query.prkHeaderId || '',//车场id
        couponHeaderId: this.curCouponData[this.activeIndex].id,//券id
        amount:this.hasTenantPrice?Number(this.tenantPrice)*this.couponNumber:this.curCouponData[this.activeIndex].price*this.couponNumber,//金额 单价*数量
        buyNumber: this.couponNumber,//数量
        userId: this.common.userId,
        userName:this.common.userInfo.userName,
        phone:this.common.userInfo.phone || this.common.userInfo.account,
        url: "/parking/rstParkCoupon/createParkCouponOrder"
      }
      if(Object.keys(this.common.userTenantInfo).length > 0){
        params.companyId = this.common.userTenantInfo.companyId;
        params.companyName = this.common.userTenantInfo.company;
      }
      callSpaceUp(params).then(res=>{
        console.log(res)
        this.btnCanClick = true;
        util.hideLoading()
        if(res.res.code === 10000){
          let couponType,couponData,unitPrice;
          if(this.couponT == 1){
            couponType = '免费券'
            couponData = '免费1次'
          }else if(this.couponT == 2){
            couponType = '金额券'
            couponData = this.curCouponData[this.activeIndex].diffAmount+'元/张'
          }else if(this.couponT == 3){
            couponType = '时间券'
            couponData = this.curCouponData[this.activeIndex].diffAmount+'分钟/张'
          }else{
            couponType = '折扣券'
            couponData = this.curCouponData[this.activeIndex].diffAmount/10+'折/张'
          }
          if(this.hasTenantPrice){
            unitPrice = this.tenantPrice
          }else{
            unitPrice = this.curCouponData[this.activeIndex].price
          }
          this.$router.push(`/confirmOrder?prkHeaderId=${this.$route.query.prkHeaderId}&couponType=${couponType}&couponData=${couponData}&unitPrice=${unitPrice}&number=${this.couponNumber}&orderNo=${res.body.data.orderNo}`)
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    toBuyRecord(){
      this.$router.push(`/buyRecord?prkHeaderId=${this.$route.query.prkHeaderId}`)
    },
    add(){
      let max = this.curCouponData[this.activeIndex].couponNumber-this.curCouponData[this.activeIndex].overCouponNumber;
      if(this.couponNumber == max){
        util.showToast(`最多可购买${max}张`)
        return
      }
      this.couponNumber = this.couponNumber+1

    },
    reduce(){
      if(this.couponNumber == 1){
        util.showToast('不能低于最低购买数量')
        return;
      }
      this.couponNumber = this.couponNumber-1
    },
    inputV(){
      let max = this.curCouponData[this.activeIndex].couponNumber-this.curCouponData[this.activeIndex].overCouponNumber;
      // if(this.couponNumber < 1){
      //   util.showToast('不能低于最低购买数量')
      //   this.couponNumber = 1
      // }else
      if(this.couponNumber > max){
        util.showToast(`最多可购买${max}张`)
        this.couponNumber = max
      }
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
// 选择购券类型
.select_box{
  margin:40px 40px 0;
  h2{
    height:44px;
    font-size:32px;
    color:rgba(51,51,51,1);
    line-height:44px;
    margin-bottom: 28px;
  }
  .tab_list{
    .flex();
    span{
      width:124px;
      height:56px;
      background:rgba(244,244,244,1);
      border-radius:8px;
      text-align:center;
      line-height: 56px;
      font-size:26px;
      color:rgba(51,51,51,1);
      margin-right:20px;
      box-sizing: border-box;
      &.cur{
        border:2px solid rgba(23,64,218,1);
        background:transparent;
        color:rgba(23,64,218,1);
      }
    }
  }
}
.coupon_data{
  margin:0 28px;
  padding:26px 12px;
  height:56px;
  border-bottom: 2px solid #eaeaea;
  .flex();
  justify-content: space-between;
  align-items: center;
  position: relative;
  .img_discount{
    position: absolute;
    top:-20px;left:0;
    width:132px;
    height:40px;
  }
  .coupon_data_left{
    .flex();
    flex:1;
    height:56px;
    p{
      font-size:26px;
      color:rgba(51,51,51,1);
      margin-right:20px;
      line-height:46px;
      span{
        font-size:40px;
        color:rgba(252,63,86,1);
        margin-right: 8px;
      }
    }
    i{
      line-height: 56px;
      font-style: normal;
      font-size:26px;
      color:rgba(153,153,153,1);
      text-decoration: line-through;
    }
  }
  .coupon_data_right{
    font-size:26px;
    color:rgba(153,153,153,1);
    line-height:56px;
  }
}
// 购买数量
.buy_num{
  padding:40px 36px 120px;
  h3{
    font-size:36px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:50px;
    text-align: center;
    margin-bottom: 40px;
  }
  .num_box{
    .flex();
    justify-content: center;
    margin-bottom: 40px;
    .num_box_left{
      position: relative;
      width:88px;
      height:88px;
      border-radius:8px;
      border:2px solid rgba(234,234,234,1);
      &:after{
        position: absolute;
        left:50%;
        top:50%;
        content:'';
        transform: translate(-50%,-50%);
        width:28px;
        height:2px;
        background:rgba(51,51,51,1);
        border-radius:2px;
      }
    }
    .num_box_center{
      width:332px;
      height:88px;
      border-radius:8px;
      border:2px solid rgba(234,234,234,1);
      text-align: center;
      font-size:40px;
      color:rgba(51,51,51,1);
      margin:0 20px;
    }
    .num_box_right{
      &:before{
        position: absolute;
        left:50%;
        top:50%;
        content:'';
        transform: translate(-50%,-50%);
        width:2px;
        height:28px;
        background:rgba(51,51,51,1);
        border-radius:2px;
      }
    }
  }
  .btn_login{
    width:100%;
    text-align: center;
    height:88px;
    box-shadow: none;
  }
}
.footer_box{
  position: fixed;
  bottom:0;left:0;right:0;
  z-index:2;
  height:108px;
  background:rgba(255,255,255,1);
  box-shadow:0px -4px 16px 0px rgba(0,0,0,0.05);
  ;
  p{
    font-size:32px;
    color:rgba(51,51,51,1);
    line-height:108px;
    text-align: center;
  }
}
.swiper{
  padding-top:28px;
  padding-bottom:20px;
  width:100%;
}
/deep/ .swiper-pagination {
  color: #000;
  position: absolute;
  left: auto;
  right: 0.2rem;
  bottom: 0.2rem;
  display: inline-block;
  text-align: center;
  width: 0.7rem;
  height: 0.4rem;
  line-height: 0.4rem;
  color: #fff;
  font-size: 0.2rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0.04rem;
  .swiper-pagination-current {
    font-size: 0.28rem !important;
  }
}
/deep/ .swiper-pagination-bullets{
  bottom: 0 !important;
  right:0 !important;
  left:0 !important;
  width:auto !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .swiper-pagination{
  background:none;
}
/deep/ .swiper-pagination-bullet{
  width:20px;
  height:4px;
  border-radius:2px;
  margin:0 6px;
}
.no_mess {
    height: 90vh;
    .flex();
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
      width:368px;
      height:224px;
      margin-bottom:60px;
    }
    p{
      font-size:28px;
      color:rgba(153,153,153,1);
      line-height:40px;
      text-align:center;
    }
  }
</style>
